export default __webpack_public_path__ + "14403e7e87bba76aa31e8f11a7613c26.svg";